module.exports = __webpack_public_path__ + "static/media/crayola.d8a54f8d.png";